"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

export default function SectionChanger({ dict }: { dict: any }) {
	const pathname = usePathname().slice(3);

	return (
		<div className="sectionChanger">
			<Link className={pathname == "/about" ? "active" : ""} href={"/about"}>
				{dict.about.historyLink}
			</Link>
			<Link
				className={pathname == "/about/vision" ? "active" : ""}
				href={"/about/vision"}
			>
				{dict.about.visionLink}
			</Link>
			<Link
				className={pathname == "/about/mission" ? "active" : ""}
				href={"/about/mission"}
			>
				{dict.about.missionLink}
			</Link>
		</div>
	);
}
